import React from 'react'
import { useDispatch } from 'react-redux'
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { setLoja } from '../state/auth/authActions';

export default function LojaSelect(props) {
  const { lojas, onClose } = props;
  const [error, setError] = React.useState(false)
  const dispatch = useDispatch();

  const lojasList = lojas.map(l => typeof l === 'string' ? l : l.CO_LOJA);

  const isError = (value) => !lojasList.includes(value)

  return (
    <Autocomplete
      freeSolo
      disableClearable
      options={lojasList}
      onChange={(e, val) => {
        if (lojasList.includes(val)) {
          onClose && onClose();
          dispatch(setLoja(val));
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          // autoFocus
          label="Selecionar loja"
          margin="dense"
          variant="outlined"
          fullWidth
          onChange={(e) => setError(isError(e.target.value))}
          onSelect={(e) => setError(isError(e.target.value))}
          error={error}
          helperText={error && 'Selecione uma loja da lista'}
          InputProps={{ ...params.InputProps, type: 'search' }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      )}
    />
  )
}